<template>
    <button class="size-[32px] shrink-0 flex items-center justify-center rounded-full hover:opacity-50 lh-transition text-brand-2-950">
        <span
            class="w-[10px]"
            v-html="crossIcon"
        ></span>
    </button>
</template>

<script setup>
    import crossIcon from '@img/icons/cross.svg?raw';
</script>
